import $ from 'jquery';

const btnPlayEl = '.gallery__play';
const popupEl = '.gallery__popup';
const btnCloseEl = '.gallery__popup-close';
const containerEl = '.gallery__popup-container';
const btnPlayYoutube = '.gallery__play--youtube';
const btnPlayVimeo = '.gallery__play--vimeo';
const btnPlayLocal = '.gallery__play--local';
const btnPlayCloudflare = '.gallery__play--cloudflare';

/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {*[]}
 */
const keyCodesAvailable = [undefined, 1, 13, 32];

function open(content) {
  $(popupEl).show().animate({ opacity: 1 }, 200);
  $(containerEl).html(content);
  $('body a, body button, body input').not('.dialog-content__close, .vr-tour__dialog-close').attr('tabindex', -1);
  $(btnPlayEl).attr('tabindex', -1);
  $(btnCloseEl).attr('tabindex', 0);
}

function close() {
  $(popupEl).animate({ opacity: 0 }, 200, () => {
    $(popupEl).hide();
    $(containerEl).html('');
    $('body a, body button, body input').removeAttr('tabindex');
    $(btnCloseEl).removeAttr('tabindex');
    $(btnPlayEl).attr('tabindex', 0);
  });
}

$(document).on('click tap keyup', btnPlayEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  // eslint-disable-next-line no-undef
  if ($(window).width() < breakpoints.desktop) {
    return false;
  }

  return true;
});

$(document).on('click tap keyup', btnCloseEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  return true;
});

$(document).on('click tap keyup', btnPlayYoutube, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  const src = $(event.target).data('src');
  const player = `<iframe src="${src}?rel=0&autoplay=1&showinfo=0" width="100%" height="100%" frameborder="0" allow="autoplay" type="text/html"></iframe>`;

  open(player);

  return true;
});

$(document).on('click tap keyup', btnPlayVimeo, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  const src = $(event.target).data('src');
  const player = `<iframe src="${src}?autoplay=1&byline=false&title=false" width="100%" height="100%" frameborder="0" allow="autoplay"></iframe>`;

  open(player);

  return true;
});

$(document).on('click tap keyup', btnPlayLocal, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  const src = $(event.target).data('src');
  const player = `<video preload="auto" autoplay="true" playsinline="" tabindex="0" controls="true" class="c-video"><source src="${src}" type="video/mp4">Your browser does not support the video tag.</video>`;

  open(player);

  return true;
});

$(document).on('click tap keyup', btnPlayCloudflare, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  const src = $(event.target).data('src');
  const player = `<video-js data-setup="{}" class="c-video vjs-default-skin video-js" controls autoplay preload="auto" style="width: 100%; height: 100%;"><source src="${src}" type="application/x-mpegURL"></video-js>`;

  open(player);

  return true;
});

$(document).on('click tap keyup', btnCloseEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  return close();
});
